// extracted by mini-css-extract-plugin
export default {"bg":"auth0-imitation_bg__prHdp","auth0Card":"auth0-imitation_auth0Card__dNSUd","auth0Heading":"auth0-imitation_auth0Heading__bgIxP","auth0Body":"auth0-imitation_auth0Body__byFav"};